import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import AccountCard from '../../Accounts/AccountMgmt/AccountShowCard';

export default function AccountShowPage(props) {
	console.log('Account', props);
	return (
		<div>
			<Breadcrumb
				pageName={props.account_endpoint.name}
				category={I18n.t('admin.accounts')}
			/>
			<AccountCard account_endpoint={props.account_endpoint} />
		</div>
	);
}
